import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-vendor-category',
  templateUrl: './vendor-category.component.html',
  styleUrls: ['./vendor-category.component.scss'],
})
export class VendorCategoryComponent {

  loader:boolean = true;
  category:any=[];
  search;
  name;
  id;
  change: boolean = false;
  url;

  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }
  
      ionViewWillEnter(){
        this.url=window.location.href;
        this.getCategory();
      }
      getCategory(){
        this.loader = true;
        this.service.getOrgCategoryDetails().subscribe((res: any) => {
          this.category=res;
          this.category.map(res=>{
            Object.assign(res,{select:false})
            this.loader = false;
          })
          
        },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
      }
  
     
      getId(id){ 
          this.category.map(res => {
          if (res.id == id) {
            res.select=!res.select
          }
        })   
        var x =  this.category.filter(res => { return res.select == true });
        sessionStorage.setItem('category',JSON.stringify(x))
       }
  
       route(){
         if(this.url.includes('choose-category')){
          this.router.navigate(['/register']) 
         }else if(this.url.includes('employee-category')){
          this.router.navigate(['/vendorEmpReg'])           
         } else if(this.url.includes('org-Choose-Cate')){
          this.router.navigate(['/Org-register']) 
         }else if(this.url.includes('provider-category')){
          this.router.navigate(['/inapp-Reg']) 
         }else if(this.url.includes('supervisor-category')){
          this.router.navigate(['/supervisorReg']) 
         }else if(this.url.includes(['/manager-category'])){
          this.router.navigate(['/mangerEmpReg']) 
         }else if(this.url.includes(['/cust-Req-category'])){
          this.router.navigate(['/custReqEmpReg']) 
         }else if(this.url.includes(['/cust-care-category'])){
          this.router.navigate(['/custCareEmpReg']) 
         }
         else{
          this.router.navigate(['/employeeReg'])       
          
         }
       }

       ionViewWillLeave(){
        this.category = [];
        this.search = ""
       }
  }
  